import { SHOP_ROUTE } from './constants';

/**
 * @param {*} url requested url by user.
 * @param {*} isCustomThemeStore if store is custom theme. storeData.theme.custom_them_flag.
 * @return {boolean} return true is requested url is customStore with route-> domain/shop
 */
export function checkCustomThemeShopUrl(url, isCustomThemeStore) {
  if (!isCustomThemeStore) return false;
  if (url.substr(-5, 5) === SHOP_ROUTE) return true;
  return false;
}
